import { render, staticRenderFns } from "./checkbox-control.vue?vue&type=template&id=7b51565c&scoped=true"
import script from "./checkbox-control.vue?vue&type=script&lang=ts"
export * from "./checkbox-control.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51565c",
  null
  
)

export default component.exports